<template>
    <div id="NavBarContainer">
        <figure @click="toggleNav">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <circle cx="256" cy="256" r="230" stroke="black" stroke-width="32" fill="none"/>
                <polyline points="128,180 384,180" fill="transparent" stroke-width="32" stroke="black" stroke-linecap="round"/>
                <polyline points="128,256 384,256" fill="transparent" stroke-width="32" stroke="black" stroke-linecap="round"/>
                <polyline points="128,336 384,336" fill="transparent" stroke-width="32" stroke="black" stroke-linecap="round"/>
            </svg>
        </figure>
        <nav>
            <img src="/assets/img/ara.svg" alt="ARA LOGO" height="60" style="float: left; margin-top: 10px;">
            <ul ref="nav">
                <li>
                    <router-link to="/home">Strona główna</router-link>
                </li>
                <li>
                    <router-link to="/home/about">Nasze biuro</router-link>
                </li>
                <li>
                    <router-link to="/home/contact">Kontakt</router-link>
                </li>
                <li>
                    <router-link to="/home/special">Polecamy</router-link>
                </li>
                <li>
                    <router-link to="/search/list/1">Oferty nieruchomości</router-link>
                </li>
                <li>
                    <a href="https://facebook.com/arabiuro" target="_blank">Facebook</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>


export default {
    name: "NavBar",
    methods: {
        toggleNav () {
            const nav = this.$refs.nav.classList;
            nav.contains('active') ? nav.remove('active') : nav.add('active');
        },
        hideMenu() {
            const nav = this.$refs.nav.classList;
            nav.remove('active');
        }
    },
    created () {
        this.$router.afterEach((to, from) => {
            this.hideMenu();
        });
    }
}
</script>

<style scoped lang="scss">
#NavBarContainer {
    width: 100%;
    background: #333;
    position: fixed;
    top: 0;
    z-index: 10;
}

figure {
    display: none;
}

nav {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    height: 80px;
    background: #333;
    top: 0;

    ul {
        float: right;
        display: flex;
        height: 100%;
        align-items: center;
        margin-block-start: 0;
        margin-block-end: 0;
        padding-inline-start: 0;

        li {
            list-style-type: none;
            padding: 0;
            background: #333;
            box-sizing: border-box;
            transition: 300ms all;

            &:hover {
                background: #cb1517;

                a {
                    color: #fff;
                }
            }

            i {
                margin-right: 10px;
                font-size: 22px;
            }

            a {
                padding: 0 20px;
                text-decoration: none;
                display: flex;
                flex-direction: row-reverse;
                align-items: center;
                font: 20px/80px 'Roboto Condensed';
                color: #aaa;
            }
        }
    }
}

@media screen and (max-width: 919px) {
    figure {
        position: fixed;
        display: block;
        z-index: 1;
        top: 16px;
        right: 16px;
        margin: 0;
        padding: 0;
        cursor: pointer;

        svg {
            width: 48px;
            height: 48px;

            * {
                stroke: #cccccc;
            }
        }
    }

    nav {
        ul {
            position: absolute;
            width: 300px;
            flex-direction: column;
            right: -300px;
            transition: 300ms ease all;
            top: 80px;

            &.active {
                right: 0;
            }


            li {
                width: 100%;
                padding-left: 0;
                padding-right: 0;

                a {
                    flex-direction: row;
                    margin-left: 20px;
                    margin-right: 13px;
                    justify-content: space-between;
                    font: 16px/60px 'Roboto Condensed';
                }
            }
        }
    }
}
</style>